import { AnyAction } from 'redux';
import {
  BaseTransientState,
  VorvertragVorschaeden,
  VorvertragVorschaedenState,
} from '@ps20-frontend/frontend-models';
import type { TarifierungRequestContext } from '@ps20-frontend/preis-lib';
import {
  AngebotsId,
  DoRequest,
  GlobalAction,
  GlobalActions,
  isAngebotsIdEqual,
} from '@ps20-frontend/shop-integration-redux';

export function vorvertragVorschaedenErmitteltReducer<T extends VorvertragVorschaedenState>(
  sectionState: T,
  action: GlobalAction<Array<VorvertragVorschaeden>>,
  angebotsId: AngebotsId,
): T {
  const actionPayload: Array<VorvertragVorschaeden> = action.payload;
  const vorvertragVorschaeden = actionPayload.find(
    vvVorschaeden =>
      vvVorschaeden.appId === angebotsId.appId &&
      vvVorschaeden.angebotsId === angebotsId.angebotsId,
  );

  if (vorvertragVorschaeden != null) {
    const anzahl = vorvertragVorschaeden.anzahlVorschaeden;
    return { ...sectionState, vorvertragVorschaeden: anzahl };
  } else {
    return sectionState;
  }
}

export interface OwnPricingEvents {
  failed: string;
  successful: string[];
}

const requestNumberOf = (request: DoRequest | undefined): number | undefined =>
  (request?.additionalData as TarifierungRequestContext | undefined)?.requestNumber;

export function ownPricingErrorReducer<T extends BaseTransientState>(
  sectionState: T,
  action: AnyAction,
  ownOffer: AngebotsId,
  events: OwnPricingEvents,
): T {
  if (action.type === GlobalActions.DO_REQUEST) {
    const pricingRequest: DoRequest = action.payload;
    return pricingRequest?.errorEvent === events.failed &&
      isAngebotsIdEqual(pricingRequest, ownOffer)
      ? { ...sectionState, latestPricingRequestNumber: requestNumberOf(pricingRequest) }
      : sectionState;
  }
  const request: DoRequest | undefined = action.doRequestAction?.payload;
  if (!isAngebotsIdEqual(request, ownOffer)) {
    return sectionState;
  }
  if (action.type === events.failed) {
    const taasStatus = action.payload?.response?.data?.taasStatus;
    return { ...sectionState, fehlerCodeTaas: taasStatus?.fehlerCode ?? null };
  }
  const answersNewestRequest =
    requestNumberOf(request) !== undefined &&
    requestNumberOf(request) === sectionState?.latestPricingRequestNumber;
  return events.successful.includes(action.type) && answersNewestRequest
    ? { ...sectionState, fehlerCodeTaas: '' }
    : sectionState;
}
